import { FileTextOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema';
import { PdfElementConfigAlert } from '../common/PdfElementConfigAlert';
import { ISecondaryResumeWidget } from './ISecondaryResumeWidget';
import { SecondaryResumePreviewComponent } from './SecondaryResumePreviewComponent';
import { SecondaryResumeWidgetComponent } from './SecondaryResumeWidgetComponent';

export const SecondaryResumeWidgetConfigSchema: yup.ObjectSchema<ISecondaryResumeWidget> =
  CommonGraphicWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.SecondaryResume).required(),
  })
    .required()
    .noUnknown();

/**
 * Widget di visualizzazione riepilogo lato PDF
 */
export const SecondaryResumeWidgetType: IWidgetType<ISecondaryResumeWidget> = {
  type: WidgetType.SecondaryResume,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Riepilogo Secondario',
  icon: <FileTextOutlined />,
  hasValue: false,
  formComponent: SecondaryResumeWidgetComponent,
  configComponent: PdfElementConfigAlert,
  configValidator: SecondaryResumeWidgetConfigSchema,
  previewComponent: SecondaryResumePreviewComponent,
  translationSchema: tran.widget({}),
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [],
};
